import React, {ReactElement} from "react";

export const ProofyIconTheme = {
    Color: '#C7CAD5',
    HighlightColor: '#32B767',
    SizeSmall: 16,
    SizeMedium: 24,
};

export interface IconThemeProps {
    color?: string;
    height?: number;
    width?: number;
    highlighted?: boolean;
}

export const HelpIcon = (
    {
        color = ProofyIconTheme.Color,
        height = ProofyIconTheme.SizeMedium,
        width = ProofyIconTheme.SizeMedium,
        highlighted = false
    }: IconThemeProps
) => {
    return (
        <svg width={width}
             height={height}
             viewBox="0 0 24 24"
             fill="none"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.82388 18.5881L8.97908 18.0085C8.8374 17.9705 8.68674 17.9858 8.55556 18.0514L8.82388 18.5881ZM4 21L3.40603 20.9151C3.37447 21.1361 3.46813 21.3563 3.64917 21.4867C3.83022 21.6172 4.06872 21.6365 4.26833 21.5367L4 21ZM4.65323 16.4274L5.2472 16.5122C5.27606 16.3102 5.20026 16.1074 5.04599 15.9738L4.65323 16.4274ZM12 19.6C17.7224 19.6 22.6 15.8677 22.6 11H21.4C21.4 14.9689 17.3233 18.4 12 18.4V19.6ZM8.66869 19.1676C9.71747 19.4485 10.8377 19.6 12 19.6V18.4C10.9418 18.4 9.92602 18.262 8.97908 18.0085L8.66869 19.1676ZM4.26833 21.5367L9.09221 19.1247L8.55556 18.0514L3.73167 20.4633L4.26833 21.5367ZM4.05926 16.3425L3.40603 20.9151L4.59397 21.0849L5.2472 16.5122L4.05926 16.3425ZM1.4 11C1.4 13.2978 2.50554 15.3614 4.26047 16.881L5.04599 15.9738C3.50704 14.6412 2.6 12.8916 2.6 11H1.4ZM12 2.4C6.27764 2.4 1.4 6.13233 1.4 11H2.6C2.6 7.03111 6.67666 3.6 12 3.6V2.4ZM22.6 11C22.6 6.13233 17.7224 2.4 12 2.4V3.6C17.3233 3.6 21.4 7.03111 21.4 11H22.6Z"
                fill={highlighted ? ProofyIconTheme.HighlightColor : color}/>
        </svg>
    )
}

export const PaymentIcon = (
    {
        color = ProofyIconTheme.Color,
        height = ProofyIconTheme.SizeMedium,
        width = ProofyIconTheme.SizeMedium,
        highlighted = false,
    }: IconThemeProps
) => {
    return (
        <svg width={width}
             height={height}
             viewBox="0 0 24 24"
             fill="none"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12.6 6V7.2" stroke="#C7CAD5" strokeWidth="1.2" strokeLinecap="round"/>
            <path d="M12.6 16.8V19.2" stroke="#C7CAD5" strokeWidth="1.2" strokeLinecap="round"/>
            <path
                stroke={highlighted ? ProofyIconTheme.HighlightColor : color}
                d="M15.5996 8.80001C15.5996 8.80001 15.171 7.20001 12.5996 7.20001C10.0282 7.20001 9.59961 8.76523 9.59961 9.60001C9.59961 12.9123 15.5996 11.172 15.5996 14.4C15.5996 15.2348 15.171 16.8 12.5996 16.8C10.0282 16.8 9.59961 15.2 9.59961 15.2"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path stroke={highlighted ? ProofyIconTheme.HighlightColor : color}
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.4004 22.4C17.9232 22.4 22.4004 17.9228 22.4004 12.4C22.4004 6.87715 17.9232 2.39999 12.4004 2.39999C6.87754 2.39999 2.40039 6.87715 2.40039 12.4C2.40039 17.9228 6.87754 22.4 12.4004 22.4Z"
                  strokeWidth="1.2"
            />
        </svg>
    )
}

export const SettingsIcon = (
    {
        color = ProofyIconTheme.Color,
        height = ProofyIconTheme.SizeMedium,
        width = ProofyIconTheme.SizeMedium,
        highlighted = false,
    }: IconThemeProps
) => {
    return (
        <svg width={width}
             height={height}
             viewBox="0 0 24 24"
             fill="none"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill={highlighted ? ProofyIconTheme.HighlightColor : color}
                d="M9.7715 3.68377L9.20229 3.49404V3.49404L9.7715 3.68377ZM9.12805 5.61412L9.37442 6.16121L9.61412 6.05326L9.69726 5.80386L9.12805 5.61412ZM7.90639 6.32071L7.7861 6.90853L8.04409 6.96132L8.2576 6.80718L7.90639 6.32071ZM5.91137 5.91246L5.79109 6.50028H5.79109L5.91137 5.91246ZM4.84487 6.39216L4.32525 6.09216L4.84487 6.39216ZM3.56563 8.60787L4.08524 8.90787L3.56563 8.60787ZM3.68345 9.77134L4.13237 9.37326L4.13237 9.37326L3.68345 9.77134ZM5.03449 11.2949L5.63151 11.3546L5.65765 11.0933L5.48341 10.8968L5.03449 11.2949ZM5.03449 12.7051L5.48341 13.1032L5.65765 12.9067L5.63151 12.6454L5.03449 12.7051ZM3.68345 14.2287L4.13237 14.6268H4.13237L3.68345 14.2287ZM3.56563 15.3922L4.08524 15.0922H4.08524L3.56563 15.3922ZM4.84487 17.6079L4.32525 17.9079H4.32525L4.84487 17.6079ZM5.91137 18.0876L5.79109 17.4997L5.79109 17.4997L5.91137 18.0876ZM7.90642 17.6793L8.25763 17.1928L8.04412 17.0387L7.78613 17.0915L7.90642 17.6793ZM9.12805 18.3859L9.69726 18.1961L9.61412 17.9467L9.37442 17.8388L9.12805 18.3859ZM9.7715 20.3162L9.20229 20.506L9.7715 20.3162ZM14.2273 20.3162L14.7966 20.506L14.2273 20.3162ZM14.8708 18.3859L14.6244 17.8388L14.3847 17.9467L14.3016 18.1961L14.8708 18.3859ZM16.0924 17.6793L16.2127 17.0915L15.9547 17.0387L15.7412 17.1928L16.0924 17.6793ZM18.0876 18.0876L17.9673 18.6754L17.9673 18.6754L18.0876 18.0876ZM19.1541 17.6079L19.6737 17.9079L19.1541 17.6079ZM20.4333 15.3922L19.9137 15.0922L20.4333 15.3922ZM20.3155 14.2287L20.7644 13.8306L20.3155 14.2287ZM18.9644 12.705L18.3673 12.6453L18.3412 12.9066L18.5154 13.1031L18.9644 12.705ZM18.9644 11.295L18.5154 10.897L18.3412 11.0934L18.3673 11.3547L18.9644 11.295ZM20.3155 9.77134L19.8666 9.37326L19.8666 9.37326L20.3155 9.77134ZM20.4333 8.60787L19.9137 8.90787V8.90787L20.4333 8.60787ZM19.1541 6.39216L18.6345 6.69216L18.6345 6.69216L19.1541 6.39216ZM18.0876 5.91246L18.2079 6.50028L18.0876 5.91246ZM16.0925 6.32073L15.7413 6.8072L15.9548 6.96134L16.2128 6.90855L16.0925 6.32073ZM14.8708 5.61412L14.3016 5.80386L14.3847 6.05326L14.6244 6.16121L14.8708 5.61412ZM14.2273 3.68377L14.7966 3.49404V3.49404L14.2273 3.68377ZM10.3407 3.87351C10.3952 3.71017 10.548 3.6 10.7202 3.6V2.4C10.0315 2.4 9.42007 2.84069 9.20229 3.49404L10.3407 3.87351ZM9.69726 5.80386L10.3407 3.87351L9.20229 3.49404L8.55884 5.42439L9.69726 5.80386ZM8.2576 6.80718C8.60543 6.55606 8.97935 6.33912 9.37442 6.16121L8.88167 5.06704C8.41208 5.27852 7.96799 5.53621 7.55518 5.83424L8.2576 6.80718ZM5.79109 6.50028L7.7861 6.90853L8.02668 5.73289L6.03166 5.32464L5.79109 6.50028ZM5.36448 6.69216C5.45057 6.54305 5.62241 6.46576 5.79109 6.50028L6.03166 5.32464C5.35696 5.18657 4.6696 5.49574 4.32525 6.09216L5.36448 6.69216ZM4.08524 8.90787L5.36448 6.69216L4.32525 6.09216L3.04601 8.30787L4.08524 8.90787ZM4.13237 9.37326C4.01814 9.24444 3.99916 9.05697 4.08524 8.90787L3.04601 8.30787C2.70167 8.90429 2.7776 9.65414 3.23453 10.1694L4.13237 9.37326ZM5.48341 10.8968L4.13237 9.37326L3.23453 10.1694L4.58557 11.693L5.48341 10.8968ZM5.59942 12C5.59942 11.782 5.6103 11.5667 5.63151 11.3546L4.43747 11.2352C4.41229 11.4869 4.39942 11.742 4.39942 12H5.59942ZM5.63151 12.6454C5.6103 12.4333 5.59942 12.218 5.59942 12H4.39942C4.39942 12.258 4.41229 12.5131 4.43747 12.7648L5.63151 12.6454ZM4.13237 14.6268L5.48341 13.1032L4.58557 12.307L3.23453 13.8306L4.13237 14.6268ZM4.08524 15.0922C3.99916 14.9431 4.01814 14.7556 4.13237 14.6268L3.23453 13.8306C2.7776 14.3459 2.70167 15.0957 3.04601 15.6922L4.08524 15.0922ZM5.36448 17.3079L4.08524 15.0922L3.04601 15.6922L4.32525 17.9079L5.36448 17.3079ZM5.79109 17.4997C5.62241 17.5343 5.45057 17.457 5.36448 17.3079L4.32525 17.9079C4.6696 18.5043 5.35696 18.8135 6.03166 18.6754L5.79109 17.4997ZM7.78613 17.0915L5.79109 17.4997L6.03166 18.6754L8.02671 18.2671L7.78613 17.0915ZM9.37442 17.8388C8.97936 17.6609 8.60545 17.444 8.25763 17.1928L7.55521 18.1658C7.96801 18.4638 8.41209 18.7215 8.88167 18.933L9.37442 17.8388ZM10.3407 20.1265L9.69726 18.1961L8.55884 18.5756L9.20229 20.506L10.3407 20.1265ZM10.7202 20.4C10.548 20.4 10.3952 20.2898 10.3407 20.1265L9.20229 20.506C9.42007 21.1593 10.0315 21.6 10.7202 21.6V20.4ZM13.2787 20.4H10.7202V21.6H13.2787V20.4ZM13.6581 20.1265C13.6037 20.2898 13.4508 20.4 13.2787 20.4V21.6C13.9673 21.6 14.5788 21.1593 14.7966 20.506L13.6581 20.1265ZM14.3016 18.1961L13.6581 20.1265L14.7966 20.506L15.44 18.5756L14.3016 18.1961ZM15.7412 17.1928C15.3934 17.4439 15.0195 17.6609 14.6244 17.8388L15.1172 18.933C15.5868 18.7215 16.0308 18.4638 16.4437 18.1658L15.7412 17.1928ZM18.2079 17.4998L16.2127 17.0915L15.9722 18.2671L17.9673 18.6754L18.2079 17.4998ZM18.6345 17.3079C18.5484 17.457 18.3765 17.5343 18.2079 17.4997L17.9673 18.6754C18.642 18.8135 19.3294 18.5043 19.6737 17.9079L18.6345 17.3079ZM19.9137 15.0922L18.6345 17.3079L19.6737 17.9079L20.9529 15.6922L19.9137 15.0922ZM19.8666 14.6268C19.9808 14.7556 19.9998 14.9431 19.9137 15.0922L20.9529 15.6922C21.2973 15.0957 21.2213 14.3459 20.7644 13.8306L19.8666 14.6268ZM18.5154 13.1031L19.8666 14.6268L20.7644 13.8306L19.4133 12.3069L18.5154 13.1031ZM18.3994 12C18.3994 12.218 18.3885 12.4332 18.3673 12.6453L19.5614 12.7647C19.5866 12.513 19.5994 12.2579 19.5994 12H18.3994ZM18.3673 11.3547C18.3885 11.5668 18.3994 11.782 18.3994 12H19.5994C19.5994 11.7421 19.5866 11.487 19.5614 11.2353L18.3673 11.3547ZM19.8666 9.37326L18.5154 10.897L19.4133 11.6931L20.7644 10.1694L19.8666 9.37326ZM19.9137 8.90787C19.9998 9.05697 19.9808 9.24444 19.8666 9.37326L20.7644 10.1694C21.2213 9.65414 21.2973 8.90429 20.9529 8.30787L19.9137 8.90787ZM18.6345 6.69216L19.9137 8.90787L20.9529 8.30787L19.6737 6.09216L18.6345 6.69216ZM18.2079 6.50028C18.3765 6.46576 18.5484 6.54305 18.6345 6.69216L19.6737 6.09216C19.3294 5.49574 18.642 5.18657 17.9673 5.32464L18.2079 6.50028ZM16.2128 6.90855L18.2079 6.50028L17.9673 5.32464L15.9722 5.73291L16.2128 6.90855ZM14.6244 6.16121C15.0195 6.33913 15.3934 6.55607 15.7413 6.8072L16.4437 5.83426C16.0309 5.53622 15.5868 5.27852 15.1172 5.06704L14.6244 6.16121ZM13.6581 3.87351L14.3016 5.80386L15.44 5.42439L14.7966 3.49404L13.6581 3.87351ZM13.2787 3.6C13.4508 3.6 13.6037 3.71017 13.6581 3.87351L14.7966 3.49404C14.5788 2.84069 13.9673 2.4 13.2787 2.4V3.6ZM10.7202 3.6H13.2787V2.4H10.7202V3.6Z"
            />
            <path stroke={highlighted ? ProofyIconTheme.HighlightColor : color}
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.9996 14.4C13.3251 14.4 14.3996 13.3255 14.3996 12C14.3996 10.6745 13.3251 9.60001 11.9996 9.60001C10.6741 9.60001 9.59961 10.6745 9.59961 12C9.59961 13.3255 10.6741 14.4 11.9996 14.4Z"
                  strokeWidth="1.2"
            />
        </svg>

    )
}

export const SignOutIcon = (
    {
        color = ProofyIconTheme.Color,
        height = ProofyIconTheme.SizeMedium,
        width = ProofyIconTheme.SizeMedium,
        highlighted = false,
    }: IconThemeProps
) => {
    return (
        <svg width={width}
             height={height}
             viewBox="0 0 24 24"
             fill="none"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path stroke={highlighted ? ProofyIconTheme.HighlightColor : color}
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15 4V20H4L4 4L15 4Z"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
            />
            <path stroke={highlighted ? ProofyIconTheme.HighlightColor : color}
                  d="M12.5 12H21.5"
                  strokeWidth="1.2"
                  strokeLinecap="round"
            />
            <path stroke={highlighted ? ProofyIconTheme.HighlightColor : color}
                  d="M18.5 15L21.5 12L18.5 9"
                  strokeWidth="1.2"
                  strokeLinecap="round"
            />
        </svg>
    )
}

export const UsageIcon = (
    {
        color = ProofyIconTheme.Color,
        height = ProofyIconTheme.SizeMedium,
        width = ProofyIconTheme.SizeMedium,
        highlighted = false,
    }: IconThemeProps
) => {
    return (
        <svg width={width}
             height={height} 
             viewBox="0 0 20 20" 
             fill="none"
             xmlns="http://www.w3.org/2000/svg"
        >
            <g id="window">
                <path id="Rectangle"
                      d="M2.5 3.5C2.5 2.94772 2.94772 2.5 3.5 2.5H16.5C17.0523 2.5 17.5 2.94772 17.5 3.5V17.5H2.5V3.5Z"
                      stroke={highlighted ? ProofyIconTheme.HighlightColor : color}
                      strokeWidth="1.2" strokeLinejoin="round"
                />
                <path id="Oval 6" fillRule="evenodd" clipRule="evenodd"
                      d="M4.99935 5.83332C5.45959 5.83332 5.83268 5.46023 5.83268 4.99999C5.83268 4.53975 5.45959 4.16666 4.99935 4.16666C4.53911 4.16666 4.16602 4.53975 4.16602 4.99999C4.16602 5.46023 4.53911 5.83332 4.99935 5.83332Z"
                      fill={highlighted ? ProofyIconTheme.HighlightColor : color}/>
                <path id="Oval 6_2" fillRule="evenodd" clipRule="evenodd"
                      d="M7.49935 5.83332C7.95959 5.83332 8.33268 5.46023 8.33268 4.99999C8.33268 4.53975 7.95959 4.16666 7.49935 4.16666C7.03911 4.16666 6.66602 4.53975 6.66602 4.99999C6.66602 5.46023 7.03911 5.83332 7.49935 5.83332Z"
                      fill={highlighted ? ProofyIconTheme.HighlightColor : color}
                />
                <path id="Oval 6_3" fillRule="evenodd" clipRule="evenodd"
                      d="M9.99935 5.83332C10.4596 5.83332 10.8327 5.46023 10.8327 4.99999C10.8327 4.53975 10.4596 4.16666 9.99935 4.16666C9.53911 4.16666 9.16602 4.53975 9.16602 4.99999C9.16602 5.46023 9.53911 5.83332 9.99935 5.83332Z"
                      fill={highlighted ? ProofyIconTheme.HighlightColor : color}
                />
                <path stroke={highlighted ? ProofyIconTheme.HighlightColor : color}
                      id="Path 2"
                      d="M17.5 7.49999H2.5"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                />
            </g>
        </svg>

    )
}
